$(function(){

    // Fit Image to 200x200 Ratio

    function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
        var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
        return { width: srcWidth*ratio, height: srcHeight*ratio };
    }

    var resizeImage = function() {
        var image = $('.img');
        var width = image[0].clientWidth;
        var height = image[0].clientHeight;
        var aspectRatio = calculateAspectRatioFit(width, height, 200, 200);

        image.attr('width', aspectRatio.width);
        image.attr('height', aspectRatio.height);
    };

    $('.img').load(resizeImage);
    $('.img').ready(resizeImage);

    // Alter Background if Custom Background is set
    if ($("#custom-background").val()) {
        $("body").css({
           "background": "url('"+$("#custom-background").val()+"') no-repeat center center fixed",
           "-webkit-background-size": "cover",
           "-moz-background-size": "cover",
           "-o-background-siz": "cover",
           "background-size": "cover"
        });
    }

    var initializingMessage = $("#initializing-message").val();
    var processingMessage = $("#processing-message").val();
    var finishingMessage = $("#finishing-message").val();

    var obj = {
        login_url:"/login",
        check_queue_url:"/login/is_queue_success",
        data:{}
    }

    $(document).ajaxStart(function() {
        $(".loading").remove()
    });



    $("#login-btn").bind('click', function(event) {    
        event.preventDefault();

        var all_validates_pass = true;
        if(!$("#inputEmailMobile").val()){
            all_validates_pass = false;
            $("#inputEmailMobile").addClass('warning-input-field');
        }

        if(!$("#inputPasswordMobile").val()){
            all_validates_pass = false;
            $("#inputPasswordMobile").addClass('warning-input-field');
        }

        if(all_validates_pass){
            $("#inputEmailMobile, #inputPasswordMobile").removeClass('warning-input-field');
            obj.data.email = $("#inputEmailMobile").val();
            obj.data.password = $("#inputPasswordMobile").val();

            $("#login-message-modal").modal();
            
            $("#login-message-content").html(initializingMessage);
            setTimeout(function(){
                $("#login-message-content").fadeOut();
            }, 1000);

            setTimeout(function(){
                $("#login-message-content").html(processingMessage).fadeIn();
            }, 1300);        

            login_ajax_call(obj, function(data){
                if(data.code == 1){//e-mail and pwd are correct
                    var check_queue = setInterval(function(){
                        //check queue finish the jobs
                        check_queue_ajax_call(obj, function(data){
                            if(data){                           
                                if(data.code == 1){
                                    clearInterval(check_queue);

                                    setTimeout(function(){
                                        $("#login-message-content").fadeOut();
                                    }, 2600);                                
                                    setTimeout(function(){
                                        $("#login-message-content").html(finishingMessage).fadeIn(function(){
                                            window.location.href = data.redirect;
                                        });
                                    }, 3000);

                                }else if(data.code == 2){
                                    window.location.href = obj.login_url;
                                }
                            }
                        });

                    }, 1000);

                }else if(data.code == 2){//fail, reload login page
                    window.location.reload();
                }
            });
        }
        return false;
    })

    $("#forgot-password-btn").bind('click', function(event) {
        $(this).prop('disabled', true);
        $("#forgotPwdForm").submit();
    });
})